import {alias, createModelSchema, list} from "serializr";
import {SmartOfferBundle} from "../bundle-core/SmartOfferBundle";
import {ProductModel} from "../../product/ProductModel";
import {SmartOfferBundleKind} from "../bundle-core/SmartOfferBundleKind";

export class SmartOfferBundlePlinkoShopDouble extends SmartOfferBundle {

    constructor() {
        super(SmartOfferBundleKind.PLINKO_SHOP_DOUBLE);

        this._products = [];
    }

    get products() {
        return this._products;
    }

    set products(value) {
        this._products = value;
    }

    valid() {

        if (!this.products || this.products.length === 0) {
            return false;
        }

        if (this.products.some(v => !v || !v.valid())) {
            return false;
        }

        return super.valid();
    }

    empty() {

        if (super.empty()) {
            return true;
        }

        return !this.products || this.products.length === 0;
    }

    clone(target = undefined) {
        if (!target) {
            return super.clone(new SmartOfferBundlePlinkoShopDouble());
        } else if (target instanceof SmartOfferBundlePlinkoShopDouble) {
            return super.clone(target);
        } else {
            console.assert(false);
            return undefined;
        }
    }
}

createModelSchema(SmartOfferBundlePlinkoShopDouble, {
    _products: alias("products", list(ProductModel.schema()))
});
